<template>
  <content-div>
    <step-bar step="2" title="가입 차량 정보"></step-bar>

    <div class="contArea tpd">
      <ul class="formList">
        <text-input-form
          description="고객명을 확인하시고 입력해주세요."
          :data="item.customerName">
          <text-input :data="item.customerName" :disable="done"></text-input>
        </text-input-form>

        <text-input-form
          description="최초등록일 년월일 8자리를 확인하시고 입력해주세요."
          :data="item.vehicleRegDate">
          <text-input :data="item.vehicleRegDate" :type="'number'" :disable="done"></text-input>
        </text-input-form>

        <text-input-form
          description="자동차등록번호를 확인하시고 입력해주세요."
          :data="item.vehicleRegNum">
          <text-input :data="item.vehicleRegNum" :disable="done"></text-input>
        </text-input-form>

        <text-input-form
          description="형식 & 모델연도를 확인하시고 입력해주세요."
          :col="2"
          :data="item.model" :data-add="item.modelYear">
          <text-input :data="item.model" :disable="done"></text-input>
          <text-input :data="item.modelYear" :type="'number'" :disable="done"></text-input>
        </text-input-form>

        <text-input-form
          description="차대번호 17자리를 확인하시고 입력해주세요."
          :data="item.vehicleNumId">
          <text-input :data="item.vehicleNumId" :max="17" :disable="done"></text-input>
        </text-input-form>
      </ul>

      <ul class="listDot mgt">
        <li>차량 명의자가 변경 된 경우 서비스센터에 방문하시어 명의자 변경을 신청하셔야 차량 등록이 정상적으로 이루어집니다.</li>
      </ul>

      <button-apply before="/subscApply/vehicleReg" >
        <span v-if="done"><a class="btnL" @click="$router.push('/subscApply/pkg')">다음</a></span>
        <span v-else-if="validate"><a class="btnL" @click="submit()">차량본인인증</a></span>
        <span v-else style="background:#414243"><a class="btnL bGray">차량본인인증</a></span>
      </button-apply>

    </div>

    <popup-alert v-if="activate" 
      title="알림" 
      :btn_cancel="btnCancelFlag"
      :btn_submit_title="btnSubmitTitle"
      @close="popupClose"
    >
      <popup-msg :type="popupMsg"></popup-msg>
    </popup-alert>

    <div v-if="loading" class="loader-wrapper">
      <img src="/images/loadingbar.gif" alt="로딩">
    </div>

  </content-div>
</template>


<script>
  import axios from 'axios';
  import {api} from '@/api';
  import Const from '../../../helpers/Const'
  import SubscApplyVehicleConst from "../components/SubscApplyVehicleConst";

  import ButtonApply from "@/components/Button/ButtonSubscApply.vue";
  import StepBar from '@/components/StepBar.vue';

  import TextInput from "@/components/Input/TextInput";
  import TextInputForm from '@/components/Input/TextInputForm.vue';

  import PopupAlert from '@/components/Popup/PopupAlert.vue';
  import PopupMsg from "@/components/Popup/PopupMsgTemplate";



  export default {
    beforeRouteEnter(to, from, next) {
      if (
        from.name != 'SubscApplyVehicleReg' &&     // 구독 차량 등록증 촬영
        from.name != 'SubscApplyPkg'               // 구독 신청 패키지 선택
      ) {
        alert('잘못된 접근경로 입니다.');
        this.$store.commit("unsetTerms");  
        next('/')
      } else {
        next();
      }
    },

    components: {
      ButtonApply,
      StepBar,

      TextInput,
      TextInputForm,

      PopupAlert,
      PopupMsg,
    },

    watch: {

      'item.model.val': {
        handler (val) {
          if(this.item.model.val) {
            let value = val.toUpperCase().replace(Const.REG_EXP_SPECIAL, "");
            this.item.model.val = value;
          }
        },
      },

      'item.vehicleNumId.val': {
        handler (val) {
          if(val) {
            let value = val.toUpperCase().replace(Const.REG_EXP_SPECIAL, "");
            this.item.vehicleNumId.val = value;
          }
        },
      },
      'item.vehicleRegNum.val': {
        handler (val) {
          if(this.item.vehicleRegNum.val) {
            let value = val.replace(Const.REG_EXP_SPECIAL, "");
            this.item.vehicleRegNum.val = value;
          }
            
        },
      },
    },

    computed: {
      validate() {
        return (
          this.item.customerName.validate &&
          this.item.vehicleRegDate.validate &&
          this.item.vehicleRegNum.validate &&
          this.item.model.validate &&
          this.item.modelYear.validate &&
          this.item.vehicleNumId.validate
        )
      },

      btnSubmitTitle() {
        return (this.popupMsg == 'MATCH_USER_VEHICLE_WARNING') ? '차대번호 조회하기' : '확인';
      },
      btnCancelFlag(){
        return ['MATCH_USER_VEHICLE_WARNING'].includes(this.popupMsg);
      },
    },

    // OCR api 스캔으로 vuex에 저장했던 data 적용
    created() {
      window.scroll(0, 0);
      this.item.customerName.val = this.ocrData.owner_name;
      this.item.vehicleRegDate.val = this.ocrData.reg_date;
      this.item.vehicleRegNum.val = this.ocrData.car_reg_no;
      this.item.model.val = this.ocrData.model.model_slug;
      this.item.modelYear.val = this.ocrData.model.model_year;
      this.item.vehicleNumId.val = this.ocrData.car_vin;
    },
    
    data() {
      return {
        activate: false,
        done: false,
        // inputDisable: !this.$store.state.ocrData.need_modify_data,
        item: SubscApplyVehicleConst.ITEM,
        loading: false,
        ocrData: this.$store.state.ocrData.data,
        popupMsg: '',
      }
    },

    methods: {

      popupClose(submit){
        this.activate = false

        // 차량 매칭 실패
        if(submit && this.popupMsg == 'MATCH_USER_VEHICLE_WARNING') {
          //return this.oasRedirect('/bmw/user/vehicle');
          return this.vtgRedirect('/bmw/user/vehicle');
        }
        //차량 구독가입 체크 완료 후 이동
        else if(this.popupMsg == 'DONE_USER_VEHICLE_CHECK'){
          this.$router.push('/subscApply/pkg')
        }
        
      },

      // url 에서 paramater로 data 넘어오면 해당 data와 일치하는지 여부만 체크 (??)
      submit() {
        this.activate = false;
        this.done = false;
        this.checkInUser();
      },
      
      // plus api 에서 plus_id 로 등록된 차대번호인지(num_id) 확인 후 return
      checkInUser() {
        this.loading = true;
        const vehicle_num_id = this.item.vehicleNumId.val;
        const axiosData = {
          'vtg_id': this.$store.state.user.vtg_id,
          // 'vehicle_cat_link_slug': this.item.model.val, //차대번호로 조회
        };
        axios.get(`${api.vehicles}/showByNumId/${vehicle_num_id}`, { params: axiosData })
          .then((res) => {
            
            var vehicleData = res.data.data;
            // server에서 중복구독 여부도 체크 후 validate 넘겨주기로.
            const monthDiffIndex = this.getVehicleNumRegMonthDiff(this.item.vehicleRegDate.val);

            if(monthDiffIndex == 'reg_date_null') {
              this.popupMsg = '차량등록일을 제대로 입력해 주세요.';
              this.activate = true;
              return;
            }

            //OCR data 는 date_reg(최초등록일), model_yeal(모델연도), monthDiffIndex(차량연차_index값)을 상용한다.
            //나머지는 plus and prime data를 사용하고 있다.
            // 2022-05-26 차량번호는 OCR 데이터를 수정한 값을 사용한다.
            this.$store.commit('setVehicle', {

              date_reg_cdk: vehicleData.date_reg,
              num_reg_cdk: vehicleData.num_reg,

              date_reg: this.item.vehicleRegDate.val,
              num_reg: this.item.vehicleRegNum.val,
              num_id: vehicleData.num_id,

              model_type: vehicleData.title,
              model_year: this.item.modelYear.val,   
              month_diff_index: monthDiffIndex,

              vehicle_cat_title: vehicleData.vehicle_cat_title,
              vehicle_cat_detail: vehicleData.vehicle_cat_detail,
              vehicle_cat_detail_desc: vehicleData.vehicle_cat_detail_desc,
            });
            
            this.checkInPkg();
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            const errCode = error.response.status;
            if (errCode == 409) this.popupMsg = error.response.data.data.msg;
            else this.popupMsg = this.errorMsg(error);
            this.activate = true;
          });
      },

      checkInPkg() {
        const vehicleCats = this.$store.state.vehicleCats;
        let vehicleCatsArray = {};
        // let vehicleCat = null;

        // 가입 가능한 연차가 존재하는 차량 GET
        for (let k_pkg in vehicleCats) {
          for (let k_car in vehicleCats[k_pkg]) {
            if(vehicleCats[k_pkg][k_car].costs[this.$store.state.vehicle.month_diff_index].state) {
              //가입 가능한 패키지만 중복제거하여 수집
              vehicleCatsArray = {...vehicleCatsArray, ...vehicleCats[k_pkg]};
            }
          }
        }

        //배열화
        vehicleCatsArray = Object.keys(vehicleCatsArray).map((k) => { return {...vehicleCatsArray[k]} });

        if(vehicleCatsArray.length == 0){
          this.popupMsg = '해당 연차는 가입이 불가능합니다.';
          this.activate = true;
          return;
        }

        //보여주는 정보는 OCR 정보를 보여준다 but 저장 데이터는 plus 데이터
        this.$store.commit('setOcrData', {
          owner_name: this.item.customerName.val,
          date_reg: this.item.vehicleRegDate.val,
          num_reg: this.item.vehicleRegNum.val,
          model_slug: this.item.model.val,
          model_year: this.item.modelYear.val,
          num_id: this.item.vehicleNumId.val,
        });

        // 다음 step selected.vehicle selected.pkg 초기화
        this.$store.commit('setPkg', {
          id: 0,
          vehicle_cat_id: 0, 
          // vehicle_cat_id: vehicleCat.id, 
        });

        this.popupMsg = 'DONE_USER_VEHICLE_CHECK';
        this.activate = true;

      },

    },
  }
</script>
